function resolveLiveQuizSocketUrl(): string {
    const configured = import.meta.env.VITE_LIVE_QUIZ_SOCKET_URL;
    if (configured) {
        return configured;
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/ws/live-quiz`;
}

export const env = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:7000',
    frontendUrl: import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173',
    environment: import.meta.env.VITE_ENVIRONMENT || 'development',
    enableDebugMode: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    liveQuizSocketUrl: resolveLiveQuizSocketUrl(),
};

export const { apiBaseUrl, frontendUrl, environment, enableDebugMode, liveQuizSocketUrl } = env;
